import { roundToDecimal } from "./round-to";
import { Hct } from "@material/material-color-utilities";

// export function hexToRGB(hex) {
//     if (hex.length !== 6) {
//         // forcing the user to submit six digits (yes, I know there are shorthand ways to write colors. I dont care right now)
//         return undefined;
//     }
//     let rgb = {
//         r: parseInt(hex.substring(0, 2), 16),
//         g: parseInt(hex.substring(2, 4), 16),
//         b: parseInt(hex.substring(4, 6), 16)
//     }
//     if(isNaN(rgb.r) || isNaN(rgb.g) || isNaN(rgb.b)) {
//         // in case the user submits something that is not a hex code
//         return undefined;
//     } else {
//         return rgb;
//     }
// }
export function hexToRGB(hex) {
    
    if (hex === undefined || hex.length !== 6) {
        // forcing the user to submit six digits (yes, I know there are shorthand ways to write colors. I dont care right now)
        return undefined;
    }
    const channel = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
    // if (channel[1] === null || channel[2] === null || channel[3] === null) {
    if (channel === null) {
        return undefined
    }
    let rgb = {
        r: parseInt(channel[1], 16),
        g: parseInt(channel[2], 16),
        b: parseInt(channel[3], 16)
    }
    console.log(rgb);
    if(isNaN(rgb.r) || isNaN(rgb.g) || isNaN(rgb.b)) {
        // in case the user submits something that is not a hex code
        return undefined;
    } else {
        return rgb;
    }
}


export function rgbToHex(rgb) {
    let red = rgb.r.toString(16)
    if (red.length === 1) {
        red = '0' + red;
    }
    let green = rgb.g.toString(16)
    if (green.length === 1) {
        green = '0' + green;
    }
    let blue = rgb.b.toString(16)
    if (blue.length === 1) {
        blue = '0' + blue;
    }

    let hex = red + green + blue;
    return hex;
}

export function rgbToHSL(rgbInput) {
    // Convert RGB values to percentages
    let rgb = {
        r: rgbInput.r / 255,
        g: rgbInput.g / 255,
        b: rgbInput.b / 255
    }

    // get min and max values
    let max = Math.max(rgb.r, rgb.g, rgb.b);
    let min = Math.min(rgb.r, rgb.g, rgb.b);

    // find lightness
    let lightness = ((max + min) / 2) * 100;

    // find saturation
    let saturation = 0;
    if (min !== max) {
        if (lightness <= 50) {
            saturation = (max - min) / (max + min);
        } else {
            saturation = (max - min) / (2 - max - min);
        }
    }
    saturation *= 100;

    // find hue
    let hue;
    if (rgb.r === rgb.g && rgb.g === rgb.b) {
        // if these values match it is gray
        hue = 0;
    } else if (max === rgb.r) {
        hue = (rgb.g - rgb.b) / (max - min);
    } else if (max === rgb.g) {
        hue = 2 + (rgb.b - rgb.r) / (max - min);
    } else if (max === rgb.b) {
        hue = 4 + (rgb.r - rgb.g) / (max - min);
    }
    hue *= 60;
    if (hue < 0) {
        hue += 360;
    }

    hue = roundToDecimal(hue, 2);
    saturation = roundToDecimal(saturation, 2);
    lightness = roundToDecimal(lightness, 2);

    let hsl = {
        h: hue,
        s: saturation,
        l: lightness
    }
    return hsl;
}

export function hslToRGB(h, s, l) {
    s /= 100;
    l /= 100;
    let intensity = s * Math.min(l, 1 - l);
    function channelProcess(cStake) {
        let cFactor = (cStake + (h / 30)) % 12;
        let cIndex = l - intensity * Math.max(Math.min(cFactor - 3, 9 - cFactor, 1), -1);
        return Math.round(cIndex * 255);
    };
    let rgb = {
        r:channelProcess(0),
        g:channelProcess(8),
        b:channelProcess(4)
    }
    return rgb;
}

export function hexToHSL(hex) {
    let rgb = hexToRGB(hex);
    if (rgb === undefined) {
        return undefined;
    }
    let hsl = rgbToHSL(rgb);
    return hsl;
}

// this function is specifically for checking WCAG contrast ratio
export function getLuminance(rgbInput) {
    // Convert RGB values to percentages
    let rgb = {
        r: rgbInput.r / 255,
        g: rgbInput.g / 255,
        b: rgbInput.b / 255
    }
    // Gamma correction
    for (let channel in rgb ) {
        if (rgb[channel] <= 0.03928) {
            rgb[channel] = rgb[channel] / 12.92
        } else {
            rgb[channel] = ((rgb[channel] + 0.055) / 1.055) ** 2.4;
        }
    }

    rgb.r = rgb.r * 0.2126;
    rgb.g = rgb.g * 0.7152;
    rgb.b = rgb.b * 0.0722;

    let luminance = rgb.r + rgb.g + rgb.b;
    return luminance;
}

export function checkTextContrast(text1, text2, bg) {
    let info = {
        label: '•',
        theme: 0, // 0 means no theme
        pass: false
    };

    // Check theme 1 text first
    let textL = getLuminance(text1);
    let bgL = getLuminance(bg);
    let contrastRatio;

    // check the first theme
    info.theme = 1; 
    if (textL < bgL) {
        contrastRatio = (bgL + 0.05) / (textL + 0.05);
    } else {
        contrastRatio = (textL + 0.05) / (bgL + 0.05);
    }

    // Determine compliance level
    if (contrastRatio >= 7) {
        info.label = 'AAA';
        info.pass = true;
    } else if (contrastRatio >= 4.5) {
        info.label = 'AA';
        info.pass = true;
    } else {
        // Alternatively check theme 2 text
        info.theme = 2;
        textL = getLuminance(text2);
        if (textL < bgL) {
            contrastRatio = (bgL + 0.05) / (textL + 0.05);
        } else {
            contrastRatio = (textL + 0.05) / (bgL + 0.05);
        }
        // Determin compliance, again but for theme 2
        if (contrastRatio >= 7) {
            info.label = 'AAA';
            info.pass = true;
        } else if (contrastRatio >= 4.5) {
            info.label = 'AA';
            info.pass = true;
        } else {
            info.theme = 0; // Both theme text colors failed
        }
    }

    return info;
}

// rename and replace old function when ready
export function newContrastCheckerFunction(bgL, textData, large) {
    let swatchTextContrastData = [];

    // for every valid text hex, check the contrast
    textData.forEach((text, id) => {
        if (text.valid) {
            let textContrast = {color: text.hex};
            let textL = getLuminance(text.rgb);

            // Get the contrast ratio
            if (textL < bgL) {
                textContrast.ratio = (bgL + 0.05) / (textL + 0.05);
            } else {
                textContrast.ratio = (textL + 0.05) / (bgL + 0.05);
            }
     
            // Determine compliance level, the higher the better
            if (!large) {
                if (textContrast.ratio >= 7) {
                    textContrast.label = 'AAA';
                    textContrast.pass = true;
                } else if (textContrast.ratio >= 4.5) {
                    textContrast.label = 'AA';
                    textContrast.pass = true;
                } else {
                    textContrast.label = '•';
                    textContrast.pass = false;
                }
            } else {
                console.log('else!');
                if (textContrast.ratio >= 4.5) {
                    textContrast.label = 'AAA';
                    textContrast.pass = true;
                } else if (textContrast.ratio >= 3) {
                    textContrast.label = 'AA';
                    textContrast.pass = true;
                } else {
                    textContrast.label = '•';
                    textContrast.pass = false;
                }
            }

            
            swatchTextContrastData.push(textContrast);
        }

    });
    return swatchTextContrastData;
}

export function hctToRGB(hct) {
    const hctColor = Hct.from(hct.hue, hct.chroma, hct.tone);
    const rgbHex = hctColor.argb.toString(16).slice(2);
    const rgb = hexToRGB(rgbHex);
    return rgb
}

export function hctToHSL(hct) {
    const rgb = hctToRGB(hct);
    const hsl = rgbToHSL(rgb);
    return hsl;
}

export function hexToHCT(hex) {
    const color = Hct.fromInt('0xff' + hex);
    return {hue: color.hue, chroma: color.chroma, tone: color.tone}
}